<!-- Content -->
<div class="flex flex-1 flex-column row-gap-2">
  <!-- Header -->
  <medsurf-slide-wysiwyg-header></medsurf-slide-wysiwyg-header>
  <!-- Body -->
  <medsurf-slide-wysiwyg-body class="h-full"></medsurf-slide-wysiwyg-body>
  @if (slideAuthorFacade.currentSelectedSlide$ | async; as page) {
    <!-- Interactive Areas -->
    @if (slideAuthorFacade.currentSelectedSlideImageAreaGroups$ | async; as groups) {
      @if (groups && groups.length > 0) {
        <medsurf-design-content-panel
          [contentClass]="'medsurf-white'"
          [buttonClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
          [titleText]="'global.interactive_areas' | translate"
          [toggleable]="true">
          <div class="p-3">
            <medsurf-slide-wysiwyg-interactive-areas></medsurf-slide-wysiwyg-interactive-areas>
          </div>
        </medsurf-design-content-panel>
      }
    }
    <!-- Pois -->
    @if (page.pois.length > 0) {
      <medsurf-design-content-panel
        [contentClass]="'medsurf-white'"
        [buttonClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
        [titleText]="'global.pois' | translate"
        [toggleable]="true">
        <div class="p-3">
          <medsurf-slide-wysiwyg-pois></medsurf-slide-wysiwyg-pois>
        </div>
      </medsurf-design-content-panel>
    }
    <!-- Questions -->
    @if (page.questions.length > 0) {
      <medsurf-design-content-panel
          [contentClass]="'medsurf-white'"
          [buttonClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
          [titleText]="'global.questions' | translate"
          [toggleable]="true"
          [menuItems]="questionsMenuItems">
        <medsurf-slide-wysiwyg-questions></medsurf-slide-wysiwyg-questions>
      </medsurf-design-content-panel>
    }
  }
</div>
